<div class="chat-modal" [class.waiting-modal]="type() === 'waiting'">
  @if (type() === "waiting") {
    <p class="countdown">{{ countdown }} {{ 'CHAT_MODAL.SECONDS' | translate }}</p>
    <div class="waiting-icon">
      <img class="timer-outline" src="assets/icon/chat-timer-outline.svg" alt="">
      <img class="timer-hand" src="assets/icon/chat-waiting-hand.svg" alt="">
    </div>
  }

  @if (type() === "failed") {
    <img class="state-icon failed-icon" src="assets/icon/chat-failed-circle.svg" alt="">
    <img class="state-icon failed-x" src="assets/icon/chat-failed-x.svg" alt="">
  }

  @if (type() === "success") {
    <img class="state-icon success-icon" src="assets/icon/chat-success-circle.svg" alt="">
    <img class="state-icon success-check" src="assets/icon/chat-success-check.svg" alt="">
  }

  @if (type() === "leave-message") {
    <img class="message-icon" src="assets/icon/chat-message.svg" alt="">
  }

  <div class="divider"></div>

  <p class="message" [innerHTML]="message() | translate"></p>

  @if (type() === "leave-message") {
    <div class="buttons">
      <button class="yes-button" type="button" (click)="leaveMessage()">{{ 'LEAVE_MESSAGE.YES' | translate }}</button>
      <button class="no-button" type="button" (click)="closeModal()">{{ 'LEAVE_MESSAGE.NO' | translate }}</button>
    </div>
  } @else if (type() !== "waiting") {
    <button class="button" type="button" (click)="closeModal()">OK</button>
  }
</div>
